var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9170)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9170",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4717 16.1939L21.8307 13.7079L20.1627 14.8079L21.7997 17.2998C21.9152 17.4681 21.9815 17.6651 21.9914 17.8689C22.0013 18.0727 21.9543 18.2752 21.8557 18.4538C21.7561 18.6401 21.6071 18.7954 21.425 18.9027C21.243 19.0099 21.035 19.065 20.8237 19.0618H12.8787L14.3567 17.5868L12.9447 16.1709L10.4217 18.6878C10.2356 18.8751 10.0881 19.0972 9.98788 19.3415C9.88761 19.5857 9.83648 19.8474 9.83741 20.1114C9.83834 20.3755 9.89131 20.6367 9.99329 20.8803C10.0953 21.1239 10.2443 21.3449 10.4317 21.5308L12.9507 23.9998L14.3507 22.5728L12.8087 21.0578H20.8277C21.3997 21.0597 21.9614 20.9065 22.4532 20.6146C22.945 20.3226 23.3485 19.9028 23.6207 19.3998C23.8933 18.9035 24.0236 18.3415 23.9973 17.7759C23.971 17.2102 23.7892 16.6628 23.4717 16.1939Z",
    fill: "url(#paint0_linear_8021_9170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7596 3.01289C11.9552 3.01225 12.1481 3.05949 12.3214 3.15047C12.4946 3.24145 12.643 3.37343 12.7535 3.53489L17.0266 9.99989L14.8116 9.56289L14.4255 11.5249L18.0455 12.2389C18.3048 12.2902 18.5717 12.2896 18.8307 12.2372C19.0898 12.1847 19.3359 12.0814 19.5548 11.9333C19.7737 11.7852 19.961 11.5951 20.106 11.3741C20.251 11.1532 20.3508 10.9056 20.3995 10.6459L21.0835 6.98189L19.1166 6.61489L18.6915 8.89389L14.4226 2.43289C14.1292 1.99041 13.7297 1.62854 13.2604 1.38038C12.7911 1.13221 12.2671 1.00567 11.7363 1.01234C11.2055 1.01901 10.6848 1.15866 10.2219 1.41853C9.75901 1.6784 9.36866 2.05019 9.08656 2.49989L7.85156 4.46789L9.54456 5.53189L10.7826 3.56089C10.8849 3.39358 11.0285 3.25533 11.1995 3.15938C11.3706 3.06343 11.5634 3.01299 11.7596 3.01289Z",
    fill: "url(#paint1_linear_8021_9170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45696 10.4527L6.88696 12.7627L8.85396 12.3997L8.16996 8.73162C8.1213 8.47197 8.02169 8.22452 7.87687 8.00358C7.73205 7.78264 7.5449 7.59258 7.32621 7.44437C7.10753 7.29616 6.86165 7.19275 6.60277 7.1401C6.3439 7.08745 6.07716 7.08661 5.81796 7.13762L2.19996 7.85062L2.58696 9.81262L4.77096 9.38162L0.477953 16.2097C0.179841 16.6814 0.0151585 17.225 0.00142376 17.7829C-0.0123109 18.3407 0.125416 18.8918 0.399953 19.3777C0.672216 19.8731 1.07364 20.2856 1.56155 20.5712C2.04946 20.8568 2.60563 21.0048 3.17096 20.9997H6.99996V18.9997H3.17096C2.96254 19.0023 2.75728 18.9485 2.57699 18.844C2.39669 18.7394 2.24809 18.5879 2.14696 18.4057C2.04763 18.2318 1.99765 18.0341 2.00241 17.8339C2.00717 17.6337 2.06648 17.4386 2.17396 17.2697L6.45696 10.4527Z",
    fill: "url(#paint2_linear_8021_9170)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9170",
    x1: 16.919,
    y1: 13.7079,
    x2: 16.919,
    y2: 23.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8021_9170",
    x1: 14.4675,
    y1: 1.01208,
    x2: 14.4675,
    y2: 12.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8021_9170",
    x1: 4.42722,
    y1: 7.09998,
    x2: 4.42722,
    y2: 20.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/Loop.7bb80e98a5d8d495e37adcfb3cb50630.svg";
export { ForwardRef as ReactComponent };